import { Routes } from '@angular/router';
import {PageNotFound} from './components/page-not-found/page-not-found';
import {Login} from './components/login/login';
import {Home} from './components/home/home';
import {authGuard} from './guard/auth-guard';
import {guestGuard} from './guard/guest';
import {Dashboard} from './components/dashboard/dashboard';
import {Chargers} from './components/chargers/chargers';
import {Users} from './components/users/users';
import {Reports} from './components/reports/reports';
import {AddCharger} from './components/add-charger/add-charger';
import {ChargerInfo} from './components/charger-info/charger-info';
import {UserDetails} from './components/users/user-details/user-details';

export const routes: Routes = [
  { path: 'home', component: Home, canActivate: [authGuard], canActivateChild: [authGuard],
    children: [
      { path: 'dashboard', component: Dashboard },
      { path: 'users', component: Users },
      { path: 'users/:id', component: UserDetails },
      { path: 'chargers', component: Chargers },
      { path: 'finance', component: Reports},
      {path: 'add-charger', component: AddCharger},
      {path: 'charger-info', component: ChargerInfo},
    ],
  },
  { path: 'login', component: Login, title: 'Login', canActivate: [guestGuard] },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', component: PageNotFound },
];
